module.exports = "/static/Images/pt-br/negative.png";